import { ref, onMounted, onBeforeUnmount, nextTick } from "vue";

export function useScrollFade(elRef, { step = 240 } = {}) {
  const canScrollLeft = ref(false);
  const canScrollRight = ref(false);

  let observer = null;

  function update() {
    const el = elRef.value;
    if (!el) {
      canScrollLeft.value = false;
      canScrollRight.value = false;
      return;
    }
    canScrollLeft.value = el.scrollLeft > 0;
    canScrollRight.value = el.scrollLeft + el.clientWidth < el.scrollWidth - 1;
  }

  function scrollByDir(dir) {
    const el = elRef.value;
    if (!el) return;
    el.scrollBy({ left: dir * step, behavior: "smooth" });
  }

  function onWheel(e) {
    const el = elRef.value;
    if (!el) return;
    if (e.deltaX !== 0 || e.shiftKey) return;
    if (el.scrollWidth <= el.clientWidth) return;
    el.scrollLeft += e.deltaY;
    e.preventDefault();
  }

  onMounted(async () => {
    await nextTick();
    const el = elRef.value;
    if (!el) return;
    el.addEventListener("scroll", update, { passive: true });
    el.addEventListener("wheel", onWheel, { passive: false });
    if (typeof ResizeObserver !== "undefined") {
      observer = new ResizeObserver(update);
      observer.observe(el);
    }
    window.addEventListener("resize", update);
    update();
  });

  onBeforeUnmount(() => {
    const el = elRef.value;
    if (el) {
      el.removeEventListener("scroll", update);
      el.removeEventListener("wheel", onWheel);
    }
    if (observer) {
      observer.disconnect();
      observer = null;
    }
    window.removeEventListener("resize", update);
  });

  return { canScrollLeft, canScrollRight, scrollByDir, update };
}
